import CarrierChecklist from "./CarrierChecklist";

/** Lead IDs that always stay on the submission: everyone already sent it. */
export const lockedLeadIdsOf = (submission) =>
  (submission?.sharedWithParties || []).filter((l) => l.status !== "selected").map((l) => l.partyId);

/** The full list to PUT to potential-leads: the locked leads plus the chosen ones. */
export const fullLeadList = (submission, chosenIds) => [
  ...new Set([...lockedLeadIdsOf(submission), ...chosenIds]),
];

/**
 * Checkbox list of carrier parties (Insurer / Reinsurer) to choose as potential
 * leads. Parties already sent the submission stay ticked; the broker's own
 * sender party isn't offered (SENDER_CANNOT_BE_LEAD).
 */
const PotentialLeadsPicker = ({ submission, value, onChange }) => (
  <CarrierChecklist
    value={value}
    onChange={onChange}
    lockedIds={lockedLeadIdsOf(submission)}
    lockedLabel="already sent"
    excludeIds={[submission?.sender?.partyId]}
  />
);

export default PotentialLeadsPicker;
